export default "__VITE_ASSET__2fba31cc__"